import React from 'react';
import { useAdminDesign } from './AdminDesignScope';
interface Props extends React.TableHTMLAttributes<HTMLTableElement> { title?: string; }
export default function AdminTable({title='Listado de registros',children,...props}:Props) {
 const active=useAdminDesign();
 if(!active)return <table {...props}>{children}</table>;
 return <section className="admin-table-frame luma-table resource-panel panel" data-admin-table-frame="true"><div className="admin-table-scroll"><table aria-label={title} {...props}>{children}</table></div></section>;
}
